import { useState } from "react"
import { Tooltip } from "reactstrap"
import ActionButton from "Components/atoms/buttons/action-button"
import SyncLog from "models/sync-log"
import { SyncIcon } from "Components/atoms/icons"
import { formatDateTimeAmPm } from "utils/tools"

interface SyncButtonProps {
    isSyncing: boolean
    syncLog?: SyncLog
    onClick: () => void
    id: string
}

// Sync button; the last sync time shows in a tooltip on hover. While a sync runs (useSyncProcess)
// the button shows a spinner and stays disabled until the new sync log arrives.
const SyncButton = ({ isSyncing, syncLog, onClick, id }: SyncButtonProps) => {
    const [isTooltipOpen, setIsTooltipOpen] = useState(false)

    const status = isSyncing
        ? "Sync in progress…"
        : syncLog?.syncedAt
            ? `Last synced ${formatDateTimeAmPm(syncLog.syncedAt)}`
            : "Never synced"

    // The tooltip targets the wrapper, since a disabled button does not fire hover events
    return (
        <div id={id} className="sync-button">
            <ActionButton onClick={onClick} disabled={isSyncing}>
                {isSyncing ? <>Syncing <SyncIcon className="mdi-spin" /></> : <>Sync <SyncIcon /></>}
            </ActionButton>
            <Tooltip target={id} isOpen={isTooltipOpen} toggle={() => setIsTooltipOpen(!isTooltipOpen)} placement="bottom">
                {status}
            </Tooltip>
        </div>
    )
}

export default SyncButton
